import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-flag',
  imports: [],
  templateUrl: './icon-bold-flag.html',
  styleUrl: './icon-bold-flag.css'
})
export class IconBoldFlag {
  @Input() size = '24';
  @Input() color = 'currentColor';
}
